import { useDatasetQueryContext } from '@datasets/dataset-query-context/hooks'
import { SubmissionPartial } from '@datasets/hooks/useSubmissionPartials'
import { comparisonOperatorConfigs, Operator } from '@global/constants/comparisonOperators'
import { SelectMultipleSubmissions } from './selectMultipleSubmissions'
import { DbColumnName } from '../../readGridToolbar/components/toggleColumns/types'

export interface SubmissionOption {
  id: string
  name: string
}

interface Props {
  filterIndex: number
  filterValue: SubmissionPartial | SubmissionPartial[] | SubmissionOption | SubmissionOption[]
  name: DbColumnName
  operator: Operator
  onChange: (
    idx: number,
  ) => (obj: {
    target: { value: (string | SubmissionOption)[] | SubmissionPartial | string }
  }) => void
}

export const SelectSubmission = ({ filterIndex, filterValue, operator, onChange }: Props) => {
  const { submissionPartials } = useDatasetQueryContext()

  const operatorConfig = comparisonOperatorConfigs[operator]
  const canHaveValue = Boolean(operatorConfig?.canHaveValueOperand())
  const autocompleteOptions: SubmissionOption[] = Object.entries(submissionPartials).map(
    ([key, options]) => {
      const autocompleteOption = {
        id: options.map(opt => opt.submission_id).join(','),
        name: key,
      }

      return autocompleteOption
    },
  )

  return (
    <SelectMultipleSubmissions
      filterIndex={filterIndex}
      filterValue={filterValue as SubmissionOption[]}
      options={autocompleteOptions}
      operator={operator}
      canHaveValue={canHaveValue}
      onChange={onChange}
    />
  )
}
